const AbstractRepository = require('@/lib/Repositories/AbstractRepository');
const ApiResponseUnmapper = require('@/libraries/DigiTickets/Api/ApiResponseUnmapper');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const GiftAidRate = require('@/models/GiftAidRate');

class GiftAidRateRepository extends AbstractRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     * @param {ApiClient} apiClient
     * @param {ApiRequestParams} apiRequestParams
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
        apiClient,
        apiRequestParams
    ) {
        super(dataStore, hydrator, syncStateManager);

        this.apiClient = apiClient;
        this.apiRequestParams = apiRequestParams;
    }

    getEntityClass() {
        return GiftAidRate;
    }

    getEntityName() {
        return 'Gift Aid Rate';
    }

    getTableName() {
        return DataStoreNames.GIFT_AID_RATES;
    }

    getResource() {
        return this.giftAidRateResource;
    }

    /**
     * @return {Promise<ReturnReason[]>}
     */
    findAll() {
        return super.findAll();
    }

    loadFromApi(branchID = null) {
        return this.apiClient
            .request(
                'GET',
                'giftaidrates',
                {
                    branchID, // Send the requested branchID to the API so it is used instead of any default.
                    ...this.apiRequestParams.defaultMappers(),
                }
            )
            .then((response) => ApiResponseUnmapper.transformApiResponse(response.data, 'GiftAidRate'))
            .then((data) => {
                return this.hydrator.hydrateArray(
                    data,
                    () => new (this.getEntityClass())()
                );
            });
    }
}

module.exports = GiftAidRateRepository;
